import Immigration from "./Immigration";

const normailizers = { Immigration };

export const getAdvancedFiltersNormalizers = (formName) => normailizers[formName];
